/* eslint-disable */

/** unique or primary key constraints on table "argo.udf_column_data_type" */
export enum ArgoUdfColumnDataTypeConstraint {
  /** unique or primary key constraint on columns "type" */
  UdfColumnDataTypePkey = 'udf_column_data_type_pkey'
}

export enum ArgoUdfColumnDataTypeEnum {
  /** Numeric data type */
  Number = 'number',
  /** String or Text data type */
  Text = 'text'
}

/** select columns of table "argo.udf_column_data_type" */
export enum ArgoUdfColumnDataTypeSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Type = 'type'
}

/** update columns of table "argo.udf_column_data_type" */
export enum ArgoUdfColumnDataTypeUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Type = 'type'
}

